import { persistReducer, persistStore } from 'redux-persist'
import { ListenerMiddlewareInstance, configureStore } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector, useStore } from 'react-redux'
import createSagaMiddleware from 'redux-saga'
import rootReducer from '@/stores/reducers'
import authListenerMiddleware from '@/stores/middleware/authListenerMiddleware'
import { persistConfig } from '@/stores/persistConfig'

import rootSaga from '@/sagas'

export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch

export type AppListenerMiddleware = ListenerMiddlewareInstance<RootState, AppDispatch>

const persistedReducer = persistReducer(persistConfig, rootReducer)

const sagaMiddleware = createSagaMiddleware()

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false })
    .prepend(authListenerMiddleware.middleware)
    .concat(sagaMiddleware),
})

const persistor = persistStore(store)

const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

const useAppDispatch = () => useDispatch<AppDispatch>()

const useAppStore = () => useStore<RootState>()

sagaMiddleware.run(rootSaga)

export {
  store,
  persistor,
  useAppSelector,
  useAppDispatch,
  useAppStore
}
